import { css } from 'styled-components';
import { breakpoint } from './breakpoints';

export const fontFamilyLight = css`
  font-family: ${(p) => p.theme.typography.fontFamily};
`;

export const fontFamily = css`
  font-family: ${(p) => p.theme.typography.fontFamily};
`;

export const fontFamilyMedium = css`
  font-family: ${(p) => p.theme.typography.fontFamilyMedium};
`;

export const fontFamilyBold = css`
  font-family: ${(p) => p.theme.typography.fontFamilyBold};
`;

export const fontFamilyBlack = css`
  font-family: ${(p) => p.theme.typography.fontFamilyBlack};
`;

export const buttonText = (size: string = 'medium') => css`
  font-family: ${(p) => p.theme.typography.fontFamilyBold};
  font-size: ${(p) => p.theme.typography.buttonFontSize[size]};
  line-height: ${(p) => p.theme.typography.lineHeights.text};
  text-transform: uppercase;
`;

export const text = (size: string) => css`
  font-family: ${(p) => p.theme.typography.fontFamily};
  font-size: ${(p) => p.theme.typography.fontSizeText[size]};
  font-weight: ${(p) => p.theme.typography.fontWeights.text};
  line-height: ${(p) => p.theme.typography.lineHeights.text};
`;

export const header = (size: string) => css`
  font-family: ${(p) => p.theme.typography.fontFamilyBlack};
  font-size: ${(p) => p.theme.typography.fontSizeHeader.mobile[size]};
  font-weight: ${(p) => p.theme.typography.fontWeights.black};
  line-height: ${(p) => p.theme.typography.lineHeights.header};
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;

  ${breakpoint('medium')} {
    font-size: ${(p) => p.theme.typography.fontSizeHeader.desktop[size]};
  }
`;

export const displayHeader = (size: string) => css`
  font-family: ${(p) => p.theme.typography.fontFamilyDisplayHeader};
  font-size: ${(p) => p.theme.typography.fontSizeDisplayHeader.mobile[size]};
  font-weight: ${(p) => p.theme.typography.fontWeights.displayHeader};
  line-height: ${(p) => p.theme.typography.lineHeights.displayHeader};

  ${breakpoint('medium')} {
    font-size: ${(p) => p.theme.typography.fontSizeDisplayHeader.desktop[size]};
  }
`;
